


















// Copyright © 2021 Move Closer

import { defineComponent } from '@vue/composition-api'
import { BBreadcrumb, BBreadcrumbItem } from 'bootstrap-vue'

import { BootstrapIcon } from '../Icon'

import { BootstrapBreadcrumbsProps } from './Breadcrumbs.contracts'
import { bootstrapBreadcrumbsProps, useBootstrapBreadcrumbs } from './Breadcrumbs.hooks'

/**
 * @scopedSlot icon - Exposes the `item` object that represents a single `BootstrapBreadcrumbsItem`.
 * @scopedSlot label - Exposes the `item` object that represents a single `BootstrapBreadcrumbsItem`.
 *
 * @see https://bootstrap-vue.org/docs/components/breadcrumb
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const BootstrapBreadcrumbs = defineComponent({
  name: 'BootstrapBreadcrumbs',
  components: { BBreadcrumb, BBreadcrumbItem, BootstrapIcon },
  props: bootstrapBreadcrumbsProps,

  setup (props: BootstrapBreadcrumbsProps) {
    const { isLast } = useBootstrapBreadcrumbs(props)
    return { isLast }
  }
})

export default BootstrapBreadcrumbs
